import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { axiosDefaultApi } from 'src/lib/axios';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';


const deleteOtellConType = ({otellConTypeId}: {otellConTypeId:number}): Promise<string> => {
  return axiosDefaultApi.delete(`/api/OteIIConTypes/DeleteOteIIConType/${otellConTypeId}`);
};

type QueryFnType = typeof deleteOtellConType;

type UseDeleteOtellConTypeOptions = {
  otellConTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteOtellConType = ({ config }: UseDeleteOtellConTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
      onError: (error:AxiosError<any>) => {
        if(error.response && error.response.data && error.response.data.message) {
          const responseMessage = error.response?.data.message;
          console.log(responseMessage)
          addNotification(responseMessage.toString(), 500);
          setIsNotificationVisible(true)
        }
        },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllOtellConTypes"]);
            addNotification(`Το Είδος τηλεπ. γραμμής ΟΤΕ Διαγράφηκε.`, 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: deleteOtellConType,
    })
}